import React from 'react';

import useOAuthTokens from '../util/hooks/useOAuthTokens'
import PageLoader from '../Common/PageLoader';
import ErrorMessage from '../Common/ErrorMessage';

export default () => {

	const {
		error,
		tokens,
		redirectUrl
	} = useOAuthTokens();

	if(error) {
		return (
			<ErrorMessage>
				{error.message}
			</ErrorMessage>
		);
	}

	if(!tokens) {
		return <PageLoader/>;
	}

	window.location.href = redirectUrl || '/';

	return null;
};
